/**
 * Returns the string with the first letter in upper case and the rest in lower case
 * @param str
 */
export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
